import React from 'react';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import {
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT,
} from '@oneaudi/unified-web-common';

export const TileContainer = styled.div`
  position: relative;
  overflow: visible;

  svg {
    transform: scale(1);
  }
`;

export const TileContent = styled.div`
  padding: 0 ${SYS_SPACE_FIXED_200};
`;

export const StyledLink = styled(TextLink)`
  text-decoration: none;
  color: ${SYS_COLOR_FOREGROUND_NEUTRAL_200_LIGHT};

  & :hover {
    color: ${SYS_COLOR_FOREGROUND_NEUTRAL_300_LIGHT};
  }
`;

export const GreyText = styled((props) => (
  <Text
    {...props}
    variant={{
      order: '2',
      style: 'normal',
      type: 'copy',
    }}
  />
))`
  color: #333333;
  margin-bottom: ${SYS_SPACE_FIXED_350};
`;
